import Button, { LoadingButton } from "./Button";
import { useCallback, useState } from "react";
import useAppState from "../lib/hooks/useAppState";
import { ReactComponent as WalletIcon } from "../assets/Wallet.svg";
import { Mainnet, Rinkeby, useEthers } from "@usedapp/core";
import useWalletConnect from "../lib/hooks/useWalletConnect";
import useContract from "../lib/contract/useContract";

export default function AccountInfo() {
  const { isConnected } = useAppState();
  const { account, chainId, switchNetwork } = useEthers();
  const { openWalletConnect } = useWalletConnect();
  const { cost, mint, isPaused, isLoading: isLoadingContract } = useContract();
  const [isLoading, setLoading] = useState(false);

  const handleMint = useCallback(async () => {
    try {
      setLoading(true);
      await mint();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [mint, setLoading]);

  const handleChangeNetwork = useCallback(() => {
    switchNetwork(Mainnet.chainId);
  }, [switchNetwork]);

  const renderButton = useCallback(() => {
    if (!isConnected) {
      return <Button onClick={openWalletConnect}>Connect</Button>;
    }
    if (chainId !== Mainnet.chainId && chainId !== Rinkeby.chainId) {
      return (
        <div className="space-y-2 flex flex-col items-center">
          <Button onClick={handleChangeNetwork}>
            Change network to Mainnet
          </Button>
          <div className="text-red-500">You are connected to the wrong network</div>
        </div>
      );
    }
    return (
      <div className="space-y-2 flex flex-col items-center">
        <LoadingButton
          loading={isLoading || isLoadingContract}
          onClick={handleMint}
          disabled={isPaused}
        >
          Mint {cost && `(${cost} ETH)`}
        </LoadingButton>
        {isPaused && (
          <div className="text-red-500">Minting is currently paused</div>
        )}
      </div>
    );
  }, [
    handleChangeNetwork,
    isConnected,
    openWalletConnect,
    cost,
    handleMint,
    isLoading,
    isLoadingContract,
    isPaused,
    chainId,
  ]);

  const renderAccountInfo = useCallback(() => {
    if (isConnected && account) {
      return (
        <div className="flex items-center space-x-4">
          <WalletIcon />
          <div className="pt-2">
            {account?.substr(0, 4)}...
            {account?.substr(account?.length - 4, 4)}
          </div>
        </div>
      );
    }
    return (
      <div className="flex items-center space-x-4">
        <WalletIcon />
        <div className="pt-2">Not Connected</div>
      </div>
    );
  }, [isConnected, account]);

  return (
    <div className="flex flex-col items-center space-y-4">
      {renderButton()}
      {renderAccountInfo()}
    </div>
  );
}
